import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useAssignSettingSelfServeBrandInstantAnswers, useSettingSelfServeBrandInstantAnswers } from "@faire/help-center-utils/settings/useSettingSelfServiceBrandInstantAnswers";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Clipboard } from "@faire/web--source/slate/icons/foundation/Clipboard";
import React from "react";
import { AddMultipleProducts } from "../instantAnswers/myCatalog-addMultipleProducts";
import { AddSingleProduct } from "../instantAnswers/myCatalog-addSingleProduct";
import { AllowedAndRestrictedProducts } from "../instantAnswers/myCatalog-allowedAndRestrictedProducts";
import { EditMultipleProducts } from "../instantAnswers/myCatalog-editMultipleProducts";
import { EditSingleProduct } from "../instantAnswers/myCatalog-editSingleProduct";
import { GetFaireToHelpAddProducts } from "../instantAnswers/myCatalog-getFaireToHelpAddProducts";
import { ImportProductsWithIntegrations } from "../instantAnswers/myCatalog-importProductsWithIntegrations";
import { InternationalPricing } from "../instantAnswers/myCatalog-internationalPricing";
import { ManageProductImages } from "../instantAnswers/myCatalog-manageProductImages";
import { OpenSizing } from "../instantAnswers/myCatalog-openSizing";
import { Preorders } from "../instantAnswers/myCatalog-preorders";
import { Prepacks } from "../instantAnswers/myCatalog-prepacks";
import { ProductTranslations } from "../instantAnswers/myCatalog-productTranslations";
import { Samples } from "../instantAnswers/myCatalog-samples";
import { TariffCodes } from "../instantAnswers/myCatalog-tariffCodes";
export var useMyCatalogBrandNodes = function useMyCatalogBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var enableSettingSelfServeBrandInstantAnswers = useSettingSelfServeBrandInstantAnswers();
  var assignSettingSelfServeBrandInstantAnswers = useAssignSettingSelfServeBrandInstantAnswers();
  var articles = useArticles();
  var commonFields = {
    id: "MyCatalog",
    label: strictLocalize({
      id: "FjWrdn",
      defaultMessage: [{
        "type": 0,
        "value": "Catalogue de produits"
      }]
    }),
    icon: /*#__PURE__*/React.createElement(Clipboard, {
      fontSize: "24px",
      color: "faireBlack"
    }),
    articles: [articles.ManageMyShop.CUSTOMIZE_MY_PRODUCT_TRANSLATIONS, articles.ManageMyShop.CURRENCY_SPECIFIC_PRICING, articles.ManageMyShop.SETTING_PRODUCT_INVENTORY_LEVELS, articles.ManageMyShop.ARRANGE_MY_SHOP_LISTINGS],
    level: 1,
    assignSetting: assignSettingSelfServeBrandInstantAnswers,
    sidebarTitle: strictLocalize({
      id: "BRiEk3",
      defaultMessage: [{
        "type": 0,
        "value": "Problème de catalogue"
      }]
    })
  };
  if (!enableSettingSelfServeBrandInstantAnswers) {
    return {
      MyCatalog: _objectSpread({}, commonFields)
    };
  }
  return {
    MyCatalog: _objectSpread(_objectSpread({}, commonFields), {}, {
      children: ["AddProducts", "GetFaireToHelpAddProducts", "EditProducts", "ListingSettings", "InternationalPricing"],
      shouldStopAddingDefaultOtherNodeToChildren: true
    }),
    AddProducts: {
      id: "AddProducts",
      label: strictLocalize({
        id: "KLV/cg",
        defaultMessage: [{
          "type": 0,
          "value": "Ajouter des produits"
        }]
      }),
      children: ["AddSingleProduct", "AddMultipleProducts", "ImportProductsWithIntegrations", "AllowedAndRestrictedProducts"],
      level: 2
    },
    GetFaireToHelpAddProducts: {
      id: "GetFaireToHelpAddProducts",
      label: strictLocalize({
        id: "2bh4oR",
        defaultMessage: [{
          "type": 0,
          "value": "Demander à Faire de m'aider à ajouter des produits"
        }]
      }),
      instantAnswer: GetFaireToHelpAddProducts(strictLocalize),
      articles: [articles.ManageMyShop.SUBMIT_REQUEST_TO_ADD_OR_EDIT_PRODUCTS],
      level: 2
    },
    EditProducts: {
      id: "EditProducts",
      label: strictLocalize({
        id: "0dI8Xj",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier les produits"
        }]
      }),
      children: ["EditSingleProduct", "EditMultipleProducts", "ManageProductImages"],
      level: 2
    },
    ListingSettings: {
      id: "ListingSettings",
      label: strictLocalize({
        id: "hkU+K/",
        defaultMessage: [{
          "type": 0,
          "value": "Paramètres des annonces de produits"
        }]
      }),
      children: ["Preorders", "OpenSizing", "Prepacks", "TariffCodes", "ProductTranslations", "Samples"],
      level: 2
    },
    InternationalPricing: {
      id: "InternationalPricing",
      label: strictLocalize({
        id: "Ok8AXt",
        defaultMessage: [{
          "type": 0,
          "value": "Tarification internationale"
        }]
      }),
      instantAnswer: InternationalPricing(strictLocalize),
      articles: [articles.ManageMyShop.CURRENCY_SPECIFIC_PRICING, articles.International.LOCATION_SHOP_LIVE],
      level: 2
    },
    AddSingleProduct: {
      id: "AddSingleProduct",
      label: strictLocalize({
        id: "vDAz4R",
        defaultMessage: [{
          "type": 0,
          "value": "Ajouter un seul produit"
        }]
      }),
      instantAnswer: AddSingleProduct(strictLocalize),
      articles: [articles.ManageMyShop.ADD_EDIT_PRODUCTS, articles.ManageMyShop.PREORDERS, articles.ManageMyShop.WHAT_IS_PREPACK, articles.ManageMyShop.PRODUCT_ATTRIBUTES_AND_DETAILS],
      level: 3
    },
    AddMultipleProducts: {
      id: "AddMultipleProducts",
      label: strictLocalize({
        id: "dvjurR",
        defaultMessage: [{
          "type": 0,
          "value": "Ajouter plusieurs produits"
        }]
      }),
      instantAnswer: AddMultipleProducts(strictLocalize),
      articles: [articles.ManageMyShop.ADD_EDIT_PRODUCTS],
      level: 3
    },
    ImportProductsWithIntegrations: {
      id: "ImportProductsWithIntegrations",
      label: strictLocalize({
        id: "ATsDmb",
        defaultMessage: [{
          "type": 0,
          "value": "Importer des produits avec des intégrations"
        }]
      }),
      instantAnswer: ImportProductsWithIntegrations(strictLocalize),
      articles: [articles.Integration.CAN_I_INTEGRATE_WITH_SHOPIFY, articles.Integration.PRESTASHOP_INTEGRATION_WITH_FAIRE, articles.Integration.WOOCOMMERCE_INTEGRATION_WITH_FAIRE],
      level: 3
    },
    AllowedAndRestrictedProducts: {
      id: "AllowedAndRestrictedProducts",
      label: strictLocalize({
        id: "cxfjO5",
        defaultMessage: [{
          "type": 0,
          "value": "Produits autorisés et restreints"
        }]
      }),
      instantAnswer: AllowedAndRestrictedProducts(strictLocalize),
      articles: [articles.ManageMyShop.ADD_EDIT_PRODUCTS, articles.ManageMyShop.WILL_YOU_LIST_ALL_PRODUCTS],
      level: 3
    },
    EditSingleProduct: {
      id: "EditSingleProduct",
      label: strictLocalize({
        id: "WvswQm",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier un seul produit"
        }]
      }),
      instantAnswer: EditSingleProduct(strictLocalize),
      articles: [articles.ManageMyShop.ADD_EDIT_PRODUCTS],
      level: 3
    },
    EditMultipleProducts: {
      id: "EditMultipleProducts",
      label: strictLocalize({
        id: "eGOOCM",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier plusieurs produits"
        }]
      }),
      instantAnswer: EditMultipleProducts(strictLocalize),
      articles: [articles.ManageMyShop.CAN_I_EDIT_PRODUCTS_IN_BULK],
      level: 3
    },
    ManageProductImages: {
      id: "ManageProductImages",
      label: strictLocalize({
        id: "yc775S",
        defaultMessage: [{
          "type": 0,
          "value": "Gérer les images des produits"
        }]
      }),
      instantAnswer: ManageProductImages(strictLocalize),
      articles: [articles.OptimizingMyPage.FEATURE_IMAGE_GUIDELINES],
      level: 3
    },
    Preorders: {
      id: "Preorders",
      label: strictLocalize({
        id: "cPHH95",
        defaultMessage: [{
          "type": 0,
          "value": "Précommandes"
        }]
      }),
      instantAnswer: Preorders(strictLocalize),
      articles: [articles.ManageMyShop.PREORDERS, articles.ManageMyShop.APPAREL_PREORDERS],
      level: 3
    },
    OpenSizing: {
      id: "OpenSizing",
      label: strictLocalize({
        id: "h/I5gl",
        defaultMessage: [{
          "type": 0,
          "value": "Tailles personnalisées"
        }]
      }),
      instantAnswer: OpenSizing(strictLocalize),
      articles: [articles.ManageMyShop.OPEN_SIZING],
      level: 3
    },
    Prepacks: {
      id: "Prepacks",
      label: strictLocalize({
        id: "U/5/j5",
        defaultMessage: [{
          "type": 0,
          "value": "Lots"
        }]
      }),
      instantAnswer: Prepacks(strictLocalize),
      articles: [articles.ManageMyShop.WHAT_IS_PREPACK, articles.ManageMyShop.HOW_DO_I_ADD_PRODUCTS_USING_THE_BULK_UPLOADER],
      level: 3
    },
    TariffCodes: {
      id: "TariffCodes",
      label: strictLocalize({
        id: "FPDHFA",
        defaultMessage: [{
          "type": 0,
          "value": "Codes tarifaires"
        }]
      }),
      instantAnswer: TariffCodes(strictLocalize),
      articles: [articles.FulfillingOrders.SELLING_AND_IMPORTING_PRODUCTS_INTO_EU],
      level: 3
    },
    ProductTranslations: {
      id: "ProductTranslations",
      label: strictLocalize({
        id: "HhB7V5",
        defaultMessage: [{
          "type": 0,
          "value": "Traductions de produits"
        }]
      }),
      instantAnswer: ProductTranslations(strictLocalize),
      articles: [articles.ManageMyShop.CUSTOMIZE_MY_PRODUCT_TRANSLATIONS],
      level: 3
    },
    Samples: {
      id: "Samples",
      label: strictLocalize({
        id: "wouYyC",
        defaultMessage: [{
          "type": 0,
          "value": "Échantillons"
        }]
      }),
      instantAnswer: Samples(strictLocalize),
      articles: [articles.ManageMyShop.HOW_DO_I_OFFER_FOOD_AND_DRINK_SAMPLES],
      level: 3
    }
  };
};